<template>
    <div class="mt-3">
        <b-row>
            <b-col>
                <div class="mt-1">
                    <span class="pagination-indicator">Showing to of page</span>
                </div>
            </b-col>
            <b-col>
                <b-pagination
                    hide-goto-end-buttons
                    align="right"
                    size="md"
                    class="custom-pagination">
                </b-pagination>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
